import axios from "axios";

export const JAMAAH_TOKEN_KEY = "jamaah_token";

export const jamaahApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: false,
});

jamaahApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(JAMAAH_TOKEN_KEY);
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const GENDER_LABELS = { L: "Laki-laki", P: "Perempuan" };
